import { render } from "./2faBody.vue?vue&type=template&id=1e95b6a6&scoped=true"
import script from "./2faBody.vue?vue&type=script&lang=js"
export * from "./2faBody.vue?vue&type=script&lang=js"

import "./2faBody.vue?vue&type=style&index=0&id=1e95b6a6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e95b6a6"]])

export default __exports__